import { Box, DialogContent, Stack, Typography } from '@mui/material';
import { ButtonComponent } from '@watter/shared-components';
import { ReactElement } from 'react';
import { NoInternetModalUI } from './delete-notification-style';

type IDeleteNotificationPopupProps = {
    heading: string;
    subHeading: string;
    acceptHandler: () => void;
    rejectHandler: () => void;
    iconComponent: ReactElement;
    open: boolean;
    acceptButtonLabel: string;
    rejectButtonLabel: string;
};

const DeleteNotificationPopup = ({
    heading,
    subHeading,
    acceptHandler,
    rejectHandler,
    open,
    iconComponent,
    acceptButtonLabel,
    rejectButtonLabel,
}: IDeleteNotificationPopupProps) => {
    const closePopup = () => {
        rejectHandler();
    };
    return (
        <NoInternetModalUI
            open={open}
            onClose={closePopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="changePassword"
        >
            <DialogContent>
                <Box height="100%" width="100%" justifyContent="center" display="flex" flexDirection="column">
                    {iconComponent && <Box sx={{ alignSelf: 'center' }}>{iconComponent}</Box>}
                    <Typography variant="h5" mb={0.6} className="header" textAlign="center" mt={0.6}>
                        {heading}
                    </Typography>
                    <Typography variant="subtitle1" mb={1.5} className="header" textAlign="center">
                        {subHeading}
                    </Typography>
                    <Stack rowGap={2} className="actionItems" flexDirection="row" justifyContent="center" mt={1}>
                        <Box className="cstBtnWrapper">
                            <ButtonComponent
                                size="medium"
                                variant="contained"
                                fullWidth
                                buttonName={rejectButtonLabel}
                                className="cstBtn2"
                                onClick={rejectHandler}
                            />
                        </Box>
                        <Box className="cstBtnWrapper">
                            <ButtonComponent
                                size="medium"
                                variant="contained"
                                fullWidth
                                buttonName={acceptButtonLabel}
                                className="cstBtn"
                                onClick={acceptHandler}
                            />
                        </Box>
                    </Stack>
                </Box>
            </DialogContent>
        </NoInternetModalUI>
    );
};
export { DeleteNotificationPopup };
